// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/info/index.css
// module id = 19
// module chunks = 32